import * as PlaceUtils from "./placeUtils";
import * as UrlUtils from "./urlUtils";

export type { CarSearchQueryParamValues } from "./urlUtils";

export const CarNavigationUtility = {
  ...PlaceUtils,
  ...UrlUtils,
};
